import { Component, Inject } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CommonModule, DatePipe } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { DateAdapter, MAT_DATE_FORMATS, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { ConfirmationmodalComponent } from '../shared/components/confirmationmodal/confirmationmodal.component';
import { ConfirmationMode } from '../shared/share';
import { MemberInsurerRestService } from '../../services/member-insurer-rest.service';
import { MemberInsurerServiceService } from '../../services/member-insurer-service.service';
import { NotificationService } from '../shared/services/notifications.service';
import { CustomDateAdapter } from '../shared/pipes/custom-date-adapter';
import { MY_NATIVE_DATE_FORMATS } from '../shared/pipes/date-format';
import { MedicalProvider, Roles } from '../../models/commonmodel';
import { masterProvider } from '../../models/phase1models';
import { AgePipe } from '../shared/pipes/age.pipe';



@Component({
  selector: 'app-add-member',
  standalone: true,
  imports: [MatFormFieldModule, ReactiveFormsModule, CommonModule, MatInputModule, MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatAutocompleteModule],
  templateUrl: './add-member.component.html',
  styleUrl: './add-member.component.scss',
  providers: [
    DatePipe, // optional, useful if you're formatting dates elsewhere
    { provide: DateAdapter, useClass: CustomDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: MY_NATIVE_DATE_FORMATS }
  ],
})
export class AddMemberComponent {
  selectInsurer(id: any) {
    this.selectedInsurerId = id;
    // this.notificationService.showNotification(id.toString())
    console.log( "the id is "+ " " +this.selectedInsurerId)
    this.memberform.patchValue({ mappedOrgIds: this.selectedInsurerId })

  }

  memberform!: FormGroup;
  popupTitle = 'Add Agent';
  popupSubtitle = 'Please provide the information below to add a new agent.';
  isSubmitLoading: boolean = false;
  today = new Date();
  enumConfirmationMode = ConfirmationMode;
  EditedAgent: any;
  userAccess = this.memberService.getUserAccess();
  enumRole = Roles;
  object: any;
  addedProvidersList: any[] = [];
  addedInsurerList: any[] = [];
  selectedProviderId: any;
  selectedInsurerId: any;
  userRole = this.memberService.getLoginUserRole();


  constructor(private fb: FormBuilder, public dialogRef: MatDialogRef<AddMemberComponent>, private dialog: MatDialog,
    private restService: MemberInsurerRestService, private memberService: MemberInsurerServiceService, private datepipe: DatePipe,
    private notificationService: NotificationService, @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    if (data) {
      this.EditedAgent = data;
      console.log("the matdialog data" + data.name)
      console.log(data)

      
    }

    

    this.initializeForm();

  }

  private initializeForm() {

     this.memberform=this.fb.group({
       firstName: ['', Validators.required],
        lastName: ['', Validators.required],
        dateOfBirth: [''],
        gender: ['', Validators.required],
        email: ['', [Validators.required, Validators.email]],
        phone: ['', [Validators.required, Validators.pattern(/^(\+44\s?7\d{3}|\(?07\d{3}\)?)\s?\d{3}\s?\d{3}$/)]],
        address: ['', Validators.required],
        organisationName: ['ORG35D51'],
        imgLogoUrl: [''],
        activeEndDate:['',Validators.required],
        activeStartDate:['',Validators.required],
        // adminType: ['',Validators.required],
        addedBy: [''],
        yearsOfExperience: [''],
        mappedOrgIds:['',Validators.required]
        
     })
    
    // if (this.userRole === this.enumRole.DISTRIBUTOR) {
    //   // Agent form for DISTRIBUTOR role
    //   this.memberform = this.fb.group({
    //     agentId: ['AG' + Date.now(), []], // System generated
    //     fcaReferenceNumber: ['', Validators.required],
    //     name: ['', Validators.required],
    //     email: ['', [Validators.required, Validators.email]],
    //     phone: ['', [Validators.required, Validators.pattern(/^(\+44\s?7\d{3}|\(?07\d{3}\)?)\s?\d{3}\s?\d{3}$/)]],
    //     activeStartDate: ['', Validators.required],
    //     activeEndDate: ['', Validators.required],
    //     providerId: ['']
    //   });
    // } else {
    //   // Regular member form for other roles
    //   // this.memberform = this.fb.group({
    //   //   firstName: ['', Validators.required],
    //   //   lastName: ['', Validators.required],
    //   //   dateOfBirth: ['', Validators.required],
    //   //   gender: ['', Validators.required],
    //   //   email: ['', [Validators.required, Validators.email]],
    //   //   phone: ['', [Validators.required, Validators.pattern(/^(\+44\s?7\d{3}|\(?07\d{3}\)?)\s?\d{3}\s?\d{3}$/)]],
    //   //   address: ['', Validators.required],
    //   //   yearsOfExperience: [''],
    //   //   providerId: ['']
    //   // });
    // }
  }

  ngOnInit() {




  
     if (this.EditedAgent.role === 'DISTRIBUTOR' || this.EditedAgent.role==='INSURER' || this.EditedAgent.role==='PROVIDER') {
       this.memberform.get('firstName')?.disable();
          this.memberform.get('lastName')?.disable();
        // this.memberform.get('agentId')?.disable();
        // this.memberform.get('fcaReferenceNumber')?.disable();
        // Fill agent form fields
        console.log("the edit data to be displayed is  " + this.EditedAgent)
        // this.memberform.patchValue({
        //   agentId: this.EditedAgent.agentId || 'AG' + Date.now(),
        //   fcaReferenceNumber: this.EditedAgent.fcaReferenceNumber || '',
        //   name: this.EditedAgent.name|| '',
        //   email: this.EditedAgent.email || '',
        //   phone: this.EditedAgent.phone || '',
        //   activeStartDate: this.EditedAgent.activeStartDate ? new Date(this.EditedAgent.activeStartDate) : null,
        //   activeEndDate: this.EditedAgent.activeEndDate ? new Date(this.EditedAgent.activeEndDate) : null,
        //   mappedOrgIds: this.EditedAgent.mappedInsurers[0].id || ''
        // });
        this.selectedInsurerId = this.EditedAgent.mappedOrgs[0]?.id;
        this.selectedProviderId=this.EditedAgent.mappedOrgs[0]?.id;
        
      }

    console.log(this.userRole)
    // Set popup title and subtitle based on role
    if (this.data.role=== 'DISTRIBUTOR' ) {
      this.popupTitle = 'Add New Agent';
      this.popupSubtitle = 'Please provide the Distributor agent information below.';
      this.getAddedInsurers()
    } else if(this.data.role=== 'PROVIDER' ) {
        this.popupTitle = 'Add New Agent';
      this.popupSubtitle = 'Please provide the Provider agent information below.';
    }
     else if(this.data.role=== 'INSURER' ) {
        this.popupTitle = 'Add New Agent';
      this.popupSubtitle = 'Please provide the Insurer agent information below.';
             this.getAddedProviders();

    }

    // if (this.userRole == this.enumRole.INSURER) {
    //   this.memberform.get('providerId')?.setValidators([Validators.required]);
    //   this.getAddedProviders();
    // }
     console.log("the edit agent id" + this.EditedAgent?.id)
    // if (this.EditedAgent?.id) {
    //   if (this.userRole === this.enumRole.DISTRIBUTOR) {
    //     this.memberform.get('firstName')?.disable();
    //       this.memberform.get('lastName')?.disable();
    //   } else {
    //     if (!!this.EditedAgent?.id) {
    //       this.memberform.get('firstName')?.disable();
    //       this.memberform.get('lastName')?.disable();
    //       this.memberform.get('fcaReferenceNumber')?.disable()
    //     } else {
    //       this.memberform.get('firstName')?.enable();
    //       this.memberform.get('lastName')?.enable();
    //     }
    //   }
    //   this.preFillForm(this.EditedAgent);
      
    // }
          this.preFillForm(this.EditedAgent);


    if(this.userRole==='INSURER'){
      this.memberform.patchValue({adminType:'INSURER'})
    }
    else if(this.userRole==='PROVIDER'){
      this.memberform.patchValue({adminType:'PROVIDER'})
    }
    else if(this.userRole==='DISTRIBUTOR'){
      this.memberform.patchValue({adminType:'DISTRIBUTOR'})
    }
    

    // this.getAddedProviders();

  }

  selectProvider(id: any) {
    this.selectedProviderId = id;
    this.memberform.patchValue({ mappedOrgIds: id });
  }

  getAddedInsurers() {
    const id = this.memberService.getLoginUserPrimaryId();
    console.log(id);
    this.addedInsurerList = []
    this.restService.getadminInsurerMappedProviders().subscribe(
      (value) => {
        console.log(value);
        this.addedInsurerList = value;
        // this.memberform.patchValue({providerId:value.mappedProviders[0].id})

      }
    )


  }

  getAddedProviders() {
    this.addedProvidersList = [];
    this.restService.getadminInsurerMappedProviders().subscribe(res => {
      console.log(res)
      if (res) {
        // this.addedProvidersList = res;
        this.object = res;
        this.addedProvidersList = res;
        console.log(this.object.mappedProviders)
        // console.log( typeof( this.addedProvidersList))
      }
    }, err => {
      this.addedProvidersList = [];
    })
  }
  
  preFillForm(data: any): void {
  
    
    if (data && this.memberform) {
      if (data.role === 'DISTRIBUTOR') {
        this.popupTitle = 'Edit Agent';
        this.popupSubtitle = 'Please provide the information below to edit Distributor agent.';
      }
      
      else if(data.role=== 'PROVIDER' ) {
        this.popupTitle = 'Edit Agent';
      this.popupSubtitle = 'Please provide the information below to edit Provider agent.';
    }   else if(data.role=== 'INSURER' ) {
        this.popupTitle = 'Edit Agent';
      this.popupSubtitle = 'Please provide the information below to edit Insurer agent.';}
    else {
        this.popupTitle = 'Edit Agent';
        this.popupSubtitle = 'Please provide the information below to edit agent.';
      }
      console.log( "the prefill form " +data)
      console.log(this.userRole);

       

      this.memberform.patchValue({
        firstName:data.firstName || '',
        lastName:data.lastName || '',
        dateOfBirth:data.dateOfBirth,
        gender:data.gender || '', 
        email:data.email ||  '',
        phone:data.phone|| '',
        address:data.address || '',
        organisationName:data.orgId || '',
        imgLogoUrl:data.imagePreviewUrl || '', 
        activeEndDate:data.activeEndDate || '' ,
        activeStartDate:data.activeStartDate || '',
        adminType:data.role || '',
        yearsOfExperience:data.yearsOfExperience || '',
        addedBy:data.lastupdatedby || ''

        













      })

      // if (data.role === 'DISTRIBUTOR') {
      //   // Fill agent form fields
      //   console.log("the edit data to be displayed is  " + data)
      //   this.memberform.patchValue({
      //     agentId: data.agentId || 'AG' + Date.now(),
      //     fcaReferenceNumber: data.fcaReferenceNumber || '',
      //     name: data.name|| '',
      //     email: data.email || '',
      //     phone: data.phone || '',
      //     activeStartDate: data.activeStartDate ? new Date(data.activeStartDate) : null,
      //     activeEndDate: data.activeEndDate ? new Date(data.activeEndDate) : null,
      //     providerId: data.providerId || ''
      //   });
      // } else {
      //   // Fill regular member form fields
      //   this.memberform.patchValue({
      //     firstName: data.firstName || '',
      //     lastName: data.lastName || '',
      //     dateOfBirth: data.dateOfBirth ? new Date(data.dateOfBirth) : null,
      //     gender: data.gender || '',
      //     email: data.email || '',
      //     phone: data.phone || '',
      //     address: data.address || '',
      //     yearsOfExperience: data.yearsOfExperience || '',
      //     providerId: data.mappedProviders[0].id || '',
        
      //   });
      // }
    }
    this.selectedProviderId = data.mappedProviders[0].id;
    this.selectedInsurerId = data.mappedInsurers[0].id;
  }


  onsubmit() {

    console.log(this.memberform.value)
    const newKey=this.EditedAgent?.id?'lastupdatedby':'createdby';
    const payloadvalues=this.memberform.getRawValue()

      const newpayload={
  
                "createdby": this.memberService.getLoginUserId(),
    "firstName": payloadvalues.firstName,
    "lastName": payloadvalues.lastName,   
    "name":payloadvalues.firstName + payloadvalues.lastName,
    "dateOfBirth": payloadvalues.dateOfBirth
            ? this.datepipe.transform(payloadvalues.dateOfBirth, 'yyyy-MM-dd')
            : '',
    "gender": payloadvalues.gender,
    "email": payloadvalues.email,
    "phone": payloadvalues.phone,
    "address": payloadvalues.address,
    "yearsOfExperience": 5,
    "role": this.memberService.getLoginUserRole(),
    "activeStartDate":  payloadvalues.activeStartDate ? this.datepipe.transform(payloadvalues.activeStartDate, 'yyyy-MM-dd')
        : '',
    "activeEndDate": payloadvalues.activeEndDate ? this.datepipe.transform(payloadvalues.activeEndDate, 'yyyy-MM-dd')
        : '',
        
    "orgId":this.memberService.getOrg(),

     "mappedOrgIds": [
         payloadvalues.mappedOrgIds
      ]
  
            }

       
     const modifypayload={[newKey]:this.memberform.get('addedBy')?.value,...newpayload}
            console.log(modifypayload)
    
    const dialogConfig = new MatDialogConfig()
    dialogConfig.width = '350px';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(ConfirmationmodalComponent, dialogConfig);
    dialogRef.componentInstance.title = 'Confirm';
    dialogRef.componentInstance.mode = this.enumConfirmationMode.ADD;
    
    let addcontent=
    dialogRef.componentInstance.message = this.EditedAgent?.id ? `Are you sure you want to update agent`: 'Are you sure you want to add  agent';

    dialogRef.afterClosed().subscribe((isConfirmed: boolean) => {
      if (isConfirmed) {
        this.isSubmitLoading = true;
        let json: any  = {
          ...this.memberform.value,
          addedBy: this.memberService.getLoginUserId()
        };

        // Handle different date fields based on role
        if (this.userRole === this.enumRole.DISTRIBUTOR) {
          json.activeStartDate = this.datepipe.transform(this.memberform.value.activeStartDate, 'dd-MM-yyyy');
          json.activeEndDate = this.datepipe.transform(this.memberform.value.activeEndDate, 'dd-MM-yyyy');
        } else {
          json.dateOfBirth = this.datepipe.transform(this.memberform.value.dateOfBirth, 'dd-MM-yyyy');
        }
        if (!!this.EditedAgent?.id) {
          if (this.userRole === this.enumRole.DISTRIBUTOR) {
            delete json.agentId;
            delete json.addedBy;
          } else {
            delete json.firstName;
            delete json.lastName;
            delete json.addedBy;
          }
          this.restService.updateAgentCommon(modifypayload, this.EditedAgent?.userId).subscribe({
            next: (response) => {
              if (response) {
                this.notificationService.showNotification('Agent updated successfully.' + ' ' + response.message);
                this.closeDialog();
                this.memberService.setrefreshAgents();
              } else {
                this.notificationService.showNotification('Failed to update . Please try again.', 'error');
              }
              this.isSubmitLoading = false;
            },
            error: (error) => {
              this.isSubmitLoading = false;
              this.notificationService.showNotification(error.error.message, 'error');
            }
          });
        }
        else {

          if (this.userRole === "Previous") {
            this.restService.addAdminDisturer(modifypayload).subscribe({
              next: (value) => {
                console.log(value);
                if (value) {
                  this.notificationService.showNotification('Agent added successfully.' + ' ' + value.message);
                  this.closeDialog();
                  this.memberService.setrefreshAgents();
                }
                else {
                  this.notificationService.showNotification('Failed to add . Please try again.', 'error');

                }
                this.isSubmitLoading = false;

              }
              ,
              error: (err) => {
                console.log(err);
                this.isSubmitLoading = false;
                this.notificationService.showNotification(err.error.message, 'error');
              }

            }

            )
          }
          else if (this.userRole === 'INSURER' || this.userRole==='PROVIDER' || this.userRole==='DISTRIBUTOR' ) {
            this.restService.addAdminsCommon(modifypayload).subscribe({
              next: (response) => {
                if (response) {
                  this.notificationService.showNotification('Agent added successfully.' + ' ' + response.message);
                  this.closeDialog();
                  this.memberService.setrefreshAgents();
                } else {
                  this.notificationService.showNotification('Failed to add . Please try again.', 'error');
                }
                this.isSubmitLoading = false;
              },
              error: (error) => {
                this.isSubmitLoading = false;
                this.notificationService.showNotification(error.error.message, 'error');
              }
            });
          }
        }

      } else {
        this.memberform.markAllAsTouched();
      }
    });
  }

  closeDialog() {
    this.dialogRef.close(true)
  }

}
